var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 0.729329C10.4592 0.72933 13.2709 3.541 13.2709 7.00016C13.2709 10.4593 10.4592 13.271 7.00004 13.271C3.54087 13.271 0.729208 10.4593 0.729208 7.00016C0.729209 3.541 3.54088 0.729329 7.00004 0.729329ZM7.00004 12.396C9.97504 12.396 12.3959 9.97516 12.3959 7.00016C12.3959 4.02516 9.97504 1.60433 7.00004 1.60433C4.02504 1.60433 1.60421 4.02516 1.60421 7.00016C1.60421 9.97516 4.02504 12.396 7.00004 12.396Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.97933C7.23917 5.97933 7.4375 6.17766 7.4375 6.41683L7.4375 9.3335C7.4375 9.57266 7.23917 9.771 7 9.771C6.76083 9.771 6.5625 9.57266 6.5625 9.3335L6.5625 6.41683C6.5625 6.17766 6.76083 5.97933 7 5.97933Z",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 4.08332C7.07587 4.08332 7.15171 4.10082 7.22171 4.12999C7.29171 4.15915 7.35587 4.19999 7.41421 4.25249C7.46671 4.31082 7.50754 4.36915 7.53671 4.44499C7.56587 4.51499 7.58337 4.59082 7.58337 4.66665C7.58337 4.74249 7.56587 4.81832 7.53671 4.88832C7.50754 4.95832 7.46671 5.02249 7.41421 5.08082C7.35587 5.13332 7.29171 5.17415 7.22171 5.20332C7.08171 5.26165 6.91837 5.26165 6.77837 5.20332C6.70837 5.17415 6.64421 5.13332 6.58587 5.08082C6.53337 5.02249 6.49254 4.95832 6.46337 4.88832C6.43421 4.81832 6.41671 4.74249 6.41671 4.66665C6.41671 4.59082 6.43421 4.51499 6.46337 4.44499C6.49254 4.36915 6.53337 4.31082 6.58587 4.25249C6.64421 4.19999 6.70837 4.15915 6.77837 4.12999C6.84837 4.10082 6.92421 4.08332 7.00004 4.08332Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.e07bb6f67f6084907659da451e37bce3.svg";
export { ForwardRef as ReactComponent };